var map = {
	"./ID.webp": 788,
	"./INDO.webp": 789,
	"./MY.webp": 790,
	"./TH.webp": 791,
	"./VN.webp": 792,
	"./malaysia.webp": 793
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 396;
module.exports = webpackAsyncContext;